import { render, staticRenderFns } from "./ConversationForm.vue?vue&type=template&id=41587c62&scoped=true&"
import script from "./ConversationForm.vue?vue&type=script&lang=js&"
export * from "./ConversationForm.vue?vue&type=script&lang=js&"
import style0 from "./ConversationForm.vue?vue&type=style&index=0&id=41587c62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41587c62",
  null
  
)

export default component.exports